// extracted by mini-css-extract-plugin
export default {"paginatedFooter":"paginated-footer_paginatedFooter__M4Eq8","line":"paginated-footer_line__VdAYu"};